import { Button } from 'antd';
import { TradeInvoice } from 'views/Conversation/Sider/TradeInvoice';
import { useTranslate } from '@tolgee/react';
import { useCallback, useState } from 'react';

interface InvoiceButtonProps {
  order: Conversation.Trade.Vo;
  conversation: Conversation.Conversation;
}

export const InvoiceButton = (props: InvoiceButtonProps) => {
  const { order, conversation } = props;
  const { t } = useTranslate();
  const { platform, region, buyerNick, externalTradeId, internalBuyerId } = order;
  const { storeId } = conversation;
  const [loading, setLoading] = useState(false);

  const handler = useCallback(
    async (onClick: () => Promise<void>) => {
      setLoading(true);
      try {
        await onClick();
      } finally {
        setLoading(false);
      }
    },
    [setLoading],
  );

  return (
    <TradeInvoice
      platform={platform}
      region={region}
      buyerNick={buyerNick}
      externalTradeId={externalTradeId}
      internalBuyerId={internalBuyerId}
      internalStoreId={storeId}
      renderButton={(onClick) => (
        <Button
          className="!bg-[var(--fett-fill-300)] !border-none !text-[var(--fett-text-secondary)] hover:opacity-80"
          onClick={() => handler(onClick)}
          loading={loading}
        >
          {t('invoice.invoice')}
        </Button>
      )}
    />
  );
};
